import {
    useMemo,
} from 'react'

import StatusHandler from 'app/shared-components/StatusHandler'
import {
    ArchiveButton, ArchiveConfirmationDialog, useArchive,
} from 'app/shared-components/Archive'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'
import requests from 'app/requests/Opportunity/Opportunity.requests'
import {
    WithId,
} from 'app/types/common.types'
import useGetOpportunityById from 'app/requests/Opportunity/hooks/useGetOpportunityById'
import OpportunitiesForm from '../OpportunitiesForm'

export default function OpportunitiesUpdate({
    id,
}: Readonly<WithId<number>>) {
    const {
        Opportunities: OpportunitiesRoutes,
    } = useAccountManagementRoutes()
    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
        invalidate,
    } = useGetOpportunityById(id)

    const archive = useArchive({
        requestParamFn: data?.archived ? requests.restore
            : requests.archive,
        notificationId: 'OpportunityUpdateDto',
        title: 'Opportunity',
        data,
        redirectionAfterSuccess: generateSkyNetLink({
            domainPath: OpportunitiesRoutes.path,
        }),
    })

    const customButtons = useMemo(() => {
        return [<ArchiveButton
            onClick={archive.handleArchiveRestore}
            archived={data?.archived}
        />]
    }, [
        archive,
        data?.archived,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <>
                <OpportunitiesForm
                    onSuccess={invalidate}
                    data={data}
                    exists
                    customButtons={customButtons}
                    requestParams={requests.UpdateOpportunity({
                        opportunityId: data?.id,
                    })}
                />
                <ArchiveConfirmationDialog
                    title="Opportunity"
                    openConfirmDialog={archive.openConfirmDialog}
                    handleClose={archive.handleArchiveRestoreConfirm}
                    archived={data?.archived}
                />
            </>
        </StatusHandler>
    )
}
